import LoggerController from "../LoggerController"
import PlatformEvent from "../PlatformEvent";

export default new PlatformEvent("INFO", "StepVisit", "StepVisit", true)